import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import resume1 from "../assets/resume1.png";
import resume2 from "../assets/resume2.png";
import resume3 from "../assets/resume3.png";
import resume4 from "../assets/resume4.png";
import resume5 from "../assets/resume5.png";
import resume6 from "../assets/resume6.png";
import resume7 from "../assets/resume7.png";
import resume8 from "../assets/resume8.png";
import Resume9 from "../assets/resume9.png";
import Resume10 from "../assets/resume10.png";
import Resume11 from "../assets/resume11.png";
import Resume12 from "../assets/resume12.png";
import Resume13 from "../assets/resume13.png";
import Resume14 from "../assets/resume14.png";
import Resume15 from "../assets/resume15.png";
import Resume16 from "../assets/resume16.png";
import Resume17 from "../assets/resume17.png";
import Resume18 from "../assets/resume18.png";
import Resume19 from "../assets/resume19.png";
import Resume20 from "../assets/resume20.png";
import Resume21 from "../assets/resume21.png";
import Resume22 from "../assets/resume22.png";
import Resume23 from "../assets/resume23.png";
import Resume24 from "../assets/resume24.png";
import Resume25 from "../assets/resume25.png";
import Resume26 from "../assets/resume26.png";
import Resume27 from "../assets/resume27.png";
import Resume28 from "../assets/resume28.png";
import Resume29 from "../assets/resume29.png";
import Resume30 from "../assets/resume30.png";
import Resume31 from "../assets/resume31.png";
import Resume32 from "../assets/resume32.png";
import Resume33 from "../assets/resume33.png";
import Resume34 from "../assets/resume34.png";
import Resume35 from "../assets/resume35.png";
import Resume36 from "../assets/resume36.png";
import Resume37 from "../assets/resume37.png";
import Resume38 from "../assets/resume38.png";
import Resume39 from "../assets/resume39.png";
import Resume40 from "../assets/resume40.png";
import Resume41 from "../assets/resume41.png";
import Resume42 from "../assets/resume42.png";
import Resume43 from "../assets/resume43.png";
import Resume44 from "../assets/resume44.png";
import Resume45 from "../assets/resume45.png";
import Resume46 from "../assets/resume46.png";
import Resume47 from "../assets/resume47.png";
import Resume48 from "../assets/resume48.png";
import Resume49 from "../assets/resume49.png";
import Resume50 from "../assets/resume50.png";

const resumes = [
  resume1, resume2, resume3, resume4, resume5, resume6, resume7, resume8,
  Resume9, Resume10, Resume11, Resume12, Resume13, Resume14, Resume15,
  Resume16, Resume17, Resume18, Resume19, Resume20, Resume21, Resume22,
  Resume23, Resume24, Resume25, Resume26, Resume27, Resume28, Resume29,
  Resume30, Resume31, Resume32, Resume33, Resume34, Resume35, Resume36,
  Resume37, Resume38, Resume39, Resume40, Resume41, Resume42, Resume43,
  Resume44, Resume45, Resume46, Resume47, Resume48, Resume49, Resume50,
];

const templateThemes = [
  "#1a2b47","#791115ff","#1a2b47","#1a2b47","#791115ff","#1a2b47",
  "#b7e1a1","#f4b400","#8b4b2b","#2b2320","#333333","#36454F",
  "#3A5A78","#2d5c7f","#333333","#a7ad63ff","#3f51b5","#3498db",
  "#795548","#333","#333",
];

const ResumeCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(3);

  useEffect(() => {
    const update = () => {
      if (window.innerWidth < 480) setVisibleItems(1);
      else if (window.innerWidth < 768) setVisibleItems(2);
      else setVisibleItems(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const handleTemplateClick = (index) => {
    const token = localStorage.getItem("token");
    const dest = token ? "/HeadingContactPage" : "/signup";
    navigate(dest, {
      state: {
        from: "/HeadingContactPage",
        selectedTemplate: index + 1,
        selectedTheme: templateThemes[index] || "#4A90E2",
      },
    });
  };

  const totalDots = Math.ceil(resumes.length / visibleItems);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const GAP = 16;
    const handleScroll = () => {
      const itemWidth =
        container.firstChild?.firstChild?.offsetWidth || 370;
      const totalItemWidth = itemWidth + GAP;
      const newIdx = Math.round(container.scrollLeft / totalItemWidth);
      setCurrentIndex(
        Math.max(0, Math.min(newIdx, resumes.length - visibleItems))
      );
    };
    container.addEventListener("scroll", handleScroll, { passive: true });
    return () => container.removeEventListener("scroll", handleScroll);
  }, [visibleItems]);

  const scroll = (dir) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const GAP = 16;
    const itemWidth = container.firstChild?.firstChild?.offsetWidth || 370;
    container.scrollBy({
      left: (itemWidth + GAP) * (dir === "left" ? -1 : 1),
      behavior: "smooth",
    });
  };

  const goToSlide = (dotIdx) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const GAP = 16;
    const itemWidth = container.firstChild?.firstChild?.offsetWidth || 370;
    container.scrollTo({
      left: dotIdx * visibleItems * (itemWidth + GAP),
      behavior: "smooth",
    });
  };

  const activeDot = Math.floor(currentIndex / visibleItems);

  return (
    <Box
      component="section"
      aria-labelledby="carousel-heading"
      itemScope
      itemType="https://schema.org/ImageGallery"
      sx={{
        backgroundColor: "#fff",
        py: { xs: 3, md: 4 },
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <Typography
        id="carousel-heading"
        component="h2"
        fontWeight="bold"
        gutterBottom
        color="text.primary"
        itemProp="name"
        sx={{
          px: { xs: 2, md: 4 },
          fontSize: { xs: "1rem", sm: "1.35rem", md: "1.75rem" },
          lineHeight: 1.3,
        }}
      >
        Pick one of many world-class templates and build your resume in minutes
      </Typography>

      {/* Scrollable row */}
      <Box
        ref={scrollContainerRef}
        role="region"
        aria-label="Resume template carousel"
        sx={{
          overflowX: "auto",
          whiteSpace: "nowrap",
          width: "100%",
          mt: { xs: 2.5, md: 4 },
          px: { xs: 1, md: 1 },
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          WebkitOverflowScrolling: "touch",
        }}
      >
        <Box sx={{ display: "inline-flex", gap: 2 }}>
          {resumes.map((img, idx) => (
            <Box
              key={idx}
              component={motion.div}
              initial="rest"
              whileHover="hover"
              animate="rest"
              variants={{ rest: { scale: 1 }, hover: { scale: 1.05 } }}
              role="button"
              tabIndex={0}
              aria-label={`Resume template ${idx + 1} – click to use`}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleTemplateClick(idx);
              }}
              itemScope
              itemType="https://schema.org/ImageObject"
              onClick={() => handleTemplateClick(idx)}
              sx={{
                position: "relative",
                /* Exact card sizes matching original screenshots */
                width: { xs: "170px", sm: "250px", md: "370px" },
                height: { xs: "230px", sm: "330px", md: "470px" },
                flexShrink: 0,
                backgroundColor: "#fff",
                cursor: "pointer",
                padding: { xs: "6px", md: "8px" },
                border: "1px solid #ddd",
                boxShadow: 1,
                borderRadius: "4px",
                transition: "box-shadow 0.2s",
                "&:hover": { boxShadow: 5 },
              }}
            >
              <Box
                component="img"
                src={img}
                alt={`Resume template ${idx + 1} – professional ATS-friendly`}
                loading="lazy"
                itemProp="contentUrl"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  borderRadius: "2px",
                  pointerEvents: "none",
                  display: "block",
                }}
              />

              {/* Hover overlay */}
              <Box
                component={motion.div}
                variants={{ rest: { opacity: 0 }, hover: { opacity: 1 } }}
                transition={{ duration: 0.25 }}
                aria-hidden="true"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  backgroundColor: "rgba(0,0,0,0.58)",
                }}
              >
                <Button
                  variant="contained"
                  tabIndex={-1}
                  sx={{
                    background: "linear-gradient(to right, #6a11cb, #2575fc)",
                    color: "#fff",
                    fontWeight: "bold",
                    px: { xs: 1.5, md: 3 },
                    py: { xs: 0.7, md: 1.5 },
                    borderRadius: "12px",
                    fontSize: { xs: "0.72rem", sm: "0.85rem", md: "1rem" },
                    "&:hover": {
                      background: "linear-gradient(to right, #2575fc, #6a11cb)",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTemplateClick(idx);
                  }}
                >
                  Use Template
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Arrows + Dots */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: { xs: 2, md: 3 },
          gap: { xs: 1, md: 2 },
        }}
      >
        <IconButton
          onClick={() => scroll("left")}
          aria-label="Scroll left"
          disabled={currentIndex === 0}
          size={isSmall ? "small" : "medium"}
          sx={{ backgroundColor: "#f5f5f5", "&:hover": { backgroundColor: "#e0e0e0" } }}
        >
          <ArrowBackIosIcon fontSize={isSmall ? "small" : "medium"} />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            gap: { xs: "5px", md: 1 },
            flexWrap: "wrap",
            justifyContent: "center",
            maxWidth: { xs: "180px", md: "300px" },
          }}
          role="tablist"
          aria-label="Template pages"
        >
          {Array.from({ length: totalDots }).map((_, i) => (
            <Box
              key={i}
              role="tab"
              aria-selected={activeDot === i}
              aria-label={`Page ${i + 1}`}
              onClick={() => goToSlide(i)}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") goToSlide(i);
              }}
              sx={{
                width: { xs: 8, md: 12 },
                height: { xs: 8, md: 12 },
                borderRadius: "50%",
                backgroundColor: activeDot === i ? "primary.main" : "grey.300",
                cursor: "pointer",
                transition: "background-color 0.3s",
                "&:hover": {
                  backgroundColor: activeDot === i ? "primary.main" : "grey.400",
                },
              }}
            />
          ))}
        </Box>

        <IconButton
          onClick={() => scroll("right")}
          aria-label="Scroll right"
          disabled={currentIndex >= resumes.length - visibleItems}
          size={isSmall ? "small" : "medium"}
          sx={{ backgroundColor: "#f5f5f5", "&:hover": { backgroundColor: "#e0e0e0" } }}
        >
          <ArrowForwardIosIcon fontSize={isSmall ? "small" : "medium"} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ResumeCarousel;